import "./TemplateTaskPanelLeft.css";

import { Dispatch, SetStateAction } from "react";

import { EditPencilIcon } from "../../../../assets";
import { TemplateTaskPanelData } from "../../../../models";
import { GetWorkflowTemplateResponse } from "../../../../service/query";
import { ServiceError } from "../../../../service/Shared";
import { Button, Column, Divider, ErrorBox, FormLabel, Row, TextArea, TextInput } from "../../../../widget";

export interface TemplateTaskPanelLeftProps {
  errors: ServiceError[] | undefined;
  canEditTask: boolean;
  workflowTemplate: GetWorkflowTemplateResponse | undefined;

  isTitleEditable: boolean;
  setIsTitleEditable: Dispatch<SetStateAction<boolean>>;
  currentTemplateTask: TemplateTaskPanelData;
  setCurrentTemplateTask: Dispatch<SetStateAction<TemplateTaskPanelData>>;

  handleSubmit: () => Promise<void>;
  handleCloseTaskPanel: () => void;
  isHandleSubmitLoading: boolean;
  isNewTask: boolean;
}

export const TemplateTaskPanelLeft = ({
  errors,
  canEditTask,
  workflowTemplate,

  isTitleEditable,
  setIsTitleEditable,
  currentTemplateTask,
  setCurrentTemplateTask,

  handleSubmit,
  handleCloseTaskPanel,
  isHandleSubmitLoading,
  isNewTask,
}: TemplateTaskPanelLeftProps): JSX.Element => {
  return (
    <div className="TemplateTaskPanelLeft">
      {errors && errors.length > 0 && (
        <Row spacingV="ml">
          <Column span={12}>
            <ErrorBox text={errors.map((error) => error.message)} />
          </Column>
        </Row>
      )}
      <Row spacingV={isTitleEditable ? "ml" : "s"}>
        <Column span={12}>
          {isTitleEditable || isNewTask ? (
            <TextInput
              name="Editable Title"
              label="Name*"
              placeholder="Add task name"
              value={currentTemplateTask?.defaultTaskName}
              onChange={(value) => setCurrentTemplateTask({ ...currentTemplateTask, defaultTaskName: value })}
              maxLength={100}
              displayCharacterCount
            />
          ) : (
            <div className="TemplateTaskPanelTitle">
              <h1>{currentTemplateTask?.defaultTaskName}</h1>
              {canEditTask && (
                <Button
                  text=""
                  icon={<EditPencilIcon />}
                  variant="secondary"
                  onClick={() => setIsTitleEditable(true)}
                  minWidth={false}
                  hasNoPadding
                />
              )}
            </div>
          )}
        </Column>
      </Row>
      <Row spacingV="ll">
        <Column span={12}>
          <p className="body1">{workflowTemplate?.name}</p>
        </Column>
      </Row>
      <Row spacingV="xl">
        <Column span={12}>
          {canEditTask ? (
            <TextArea
              name="Description"
              label="Description"
              value={currentTemplateTask?.defaultTaskDescription ?? ""}
              displayCharacterCount
              maxLength={500}
              onChange={(value) => setCurrentTemplateTask({ ...currentTemplateTask, defaultTaskDescription: value })}
            />
          ) : (
            <>
              <FormLabel label="Description" />
              <p className="body1">{currentTemplateTask?.defaultTaskDescription ?? ""}</p>
            </>
          )}
        </Column>
      </Row>
      <Row spacingV="xl">
        <Column span={12}>
          <Divider type="horizontal" />
        </Column>
      </Row>
      {canEditTask && (
        <Row>
          <Column span={12}>
            <Button text="Save" onClick={handleSubmit} hasNoPadding isLoading={isHandleSubmitLoading} />
            <Button text="Cancel" variant="secondary" onClick={handleCloseTaskPanel} hasNoPadding />
          </Column>
        </Row>
      )}
    </div>
  );
};
